import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";

/* flow */
var cleanStateKey = function cleanStateKey(key) {
  return key === null || typeof key === 'undefined' ? 'main' : key.toString();
};

export default cleanStateKey;